import React from "react";
import { FieldProps } from "react-jsonschema-form";
import { WitLabel } from "./common";

export default function SectionUnderline({ schema, idSchema }: FieldProps) {
  return <WitLabel id={idSchema.$id}>{schema.title}</WitLabel>;
}
